import { fromPromise } from 'xstate';

import {
  type CreateAccountActorInput,
  type CreateAccountOutput,
  type RefreshAccessTokensInput,
  type RefreshAccessTokensOutput,
  type SignInInput,
  type SignInOutput,
} from '../join-or-sign-in-machine.types';

// ─── External Actors ─────────────────────────────────────────────────────────

const signIn = fromPromise<SignInOutput, SignInInput>(async () => {
  throw new Error('`signIn` actor is not provided.');
});

const createAccount = fromPromise<CreateAccountOutput, CreateAccountActorInput>(async () => {
  throw new Error('`createAccount` actor is not provided.');
});

const refreshAccessTokens = fromPromise<RefreshAccessTokensOutput, RefreshAccessTokensInput>(
  async () => {
    throw new Error('`refreshAccessTokens` actor is not provided.');
  },
);

// ─────────────────────────────────────────────────────────────────────────────

export const Actors = {
  signIn,
  createAccount,
  refreshAccessTokens,
};
